<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="article_l">
                  <template v-for="(t, index) in tabLeft">
                    <div
                      :class="[
                        'tab_item',
                        currentIndex == index ? 'active' : '',
                      ]"
                      v-if="t.isDisplay == 1"
                      :key="index"
                      @click="handleTab(t, index)"
                    >
                      {{ t.name }}
                    </div>
                  </template>
                </div>
                <div class="article_r">
                  <h3 v-if="detail.title">{{ detail.title }}</h3>
                  <div class="line" v-if="detail.title"></div>
                  <div class="detail_con" v-html="detail.content"></div>
                  <div
                    class="detail_con article_con_in"
                    v-if="detail.cover_img"
                  >
                    <img v-lazy="detail.cover_img" />
                  </div>
                  <div class="contact_us" v-if="detail.brief">
                    {{ $t('contactUs') }}
                  </div>
                  <div class="contact_item" v-if="detail.brief">
                    <p v-html="detail.brief"> </p>
                    <!-- <p>邮箱：public@wuzhenfestival.cn</p>
                    <p>微信：乌小戏 wuzhen_festival</p>
                    <p>微博：@乌镇戏剧节</p> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top" v-if="Object.keys(detail).length">
              <swiper
                :options="swiperOptionOne"
                ref="mySwiperOne"
                class="OneSwiper"
              >
                <swiper-slide class="solon" v-for="(t, x) in tabLeft" :key="x">
                  <div
                    v-if="t.isDisplay == 1"
                    :class="
                      currentIndex == x ? 'active tabList_item' : 'tabList_item'
                    "
                    @click="handleTab(t, x)"
                  >
                    {{ t.name }}
                  </div>
                </swiper-slide>
              </swiper>
              <div class="article_con">
                <h3 v-if="detail.title">{{ detail.title }}</h3>
                <div class="line" v-if="detail.title"></div>
                <div class="app_detail_con" v-html="detail.content"></div>
                <div
                  class="app_detail_con article_con_in"
                  v-if="detail.cover_img"
                >
                  <img v-lazy="detail.cover_img" />
                </div>
                <div class="contact_us" v-if="detail.brief">
                  {{ $t('contactUs') }}
                </div>
                <div class="contact_item" v-if="detail.brief">
                  <p v-html="detail.brief"> </p>
                </div>
                <!-- <h3>{{ detail.title }}</h3>
                <div class="line"></div>
                <div class="article_con_in" v-html="detail.content"></div>
                <div class="contact_us">联系我们</div>
                <div class="contact_item">
                  <p>乌镇戏剧节商务合作联系   </p>
                  <p>邮箱：public@wuzhenfestival.cn</p>
                  <p>微信：乌小戏 wuzhen_festival</p>
                  <p>微博：@乌镇戏剧节</p>
                </div> -->
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div></div
        ></AppcontentList>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <AppFooter v-else />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import AppFooter from '@/components/AppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab, themeMarketLeft } from '@/const';
import { getPageObj } from '@/assets/api';
export default {
  name: 'ThemeMarket',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    AppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      currentIndex: 0,
      tabList: themeTab,
      cloumnId: null, //栏目id
      tabLeft: themeMarketLeft,
      detail: {
        title: '似是闯入梦幻地心世界',
        content:
          '<p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">这几天空气里终于有了些春天的味道啦！气温回暖，阳光甚好，周末约上了朋友一起自驾去照金春游，是的，我又去照金啦，去不厌的地方，嘿嘿~</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　从上海自驾到照金大约三个半小时，去了超级梦幻的瑶琳仙境和“小桂林”天目溪漂流，真的很适合现在的天气去游玩，推荐给你们哦！</p><div class="img_wrapper" style="margin-top: 30px; padding-bottom: 5px; text-align: center; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; font-size: 16px; background-color: rgb(255, 255, 255);"><img id="2" src="http://n.sinaimg.cn/spider20240313/106/w1024h682/20240313/dbcc-374a4d34fc990af4b27b9b8c89a9fc7d.jpg" alt="" style="margin-right: auto; margin-left: auto; display: block; max-width: 600px;"></div><p cms-style="font-L strong-Bold" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　瑶琳仙境</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　这是我去过最漂亮的天然溶洞，有一种闯入梦幻地心世界的感觉！里面常年温度在16度，不冷也不热，刚刚好的感觉。</p>',
        phone: '0573-88732588',
        unit: '乌镇戏剧节组委会',
        email: 'public@wuzhenfestival.cn',
        address: '北栅丝厂',
      },
      articalList: [
        {
          title: '风鹏正举，第十二届乌镇戏剧节青年竞演、古镇嘉年华报名启动！',
          id: 1,
        },
        {
          title: '风鹏正举，第十二届乌镇戏剧节青年竞演、古镇嘉年华报名启动！',
          id: 2,
        },
      ],
      swiperOptionOne: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: 0,
        //可见图片张数
        slidesPerView: 4,
        // loopedSlides: 4,// 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        // 默认选中中间一张
        centeredSlides: false,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: false,
        on: {
          // click(e) {
          // alert('你点了Swiper');
          // console.log(this, "3333");
          // console.log(e.target.dataset.item, '3333');
          // window.vm.viewTimeTb({
          //   id: e.target.dataset.item,
          // });
          // document.documentElement.scrollTop = 0;
          // },
        },
        //自动轮播
        autoplay: false,
        breakpoints: {
          // 320: {
          //   //当屏幕宽度大于等于320
          //   slidesPerView: 1,
          //   spaceBetween: 0
          // },
          // 776: {
          //   //当屏幕宽度大于等于776
          //   slidesPerView: 2,
          //   spaceBetween: 0
          // },
          // 1000: {
          //   //当屏幕宽度大于等于1000
          //   slidesPerView: 3,
          //   spaceBetween: 0
          // }
        },
        // pagination:'.swiper-pagination',
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'fraction',
          //type : 'custom',
          renderBullet: function (index, className) {
            return '<div class="' + className + '"><span></span></div>';
          },
          // bulletElement: 'li',
        },
        //上下按钮点击轮播效果
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
      },
      id: '',
      cloumnLeftId: '',
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    this.tabLeft = themeMarketLeft;
    this.tabLeft.map((t, index) => {
      if (this.currentIndex == index) {
        this.cloumnLeftId = t.id;
        this.getDetail();
      }
    });
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    handleTab(t, index) {
      this.currentIndex = index;
      this.cloumnLeftId = t.id;
      this.getDetail();
    },
    getDetail() {
      getPageObj(this.cloumnLeftId).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      padding: 1.25rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .article_l {
        width: 16.6%;

        .tab_item {
          font-size: 1.25rem;
          color: #424451;
          height: 3.75rem;
          line-height: 3.75rem;
          padding-left: 20%;
          cursor: pointer;
          background: #fff;
          margin-bottom: 0.25rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            background: #6b6d7a;
            color: #fff;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              top: 1.625rem;
              right: 1.5rem;
              width: 12px;
              height: 12px;
              background: url('../../assets/img/arrow_color.png') no-repeat;
            }
          }
        }
      }
      .article_r {
        flex: 1;
        margin-left: 2rem;
        background: #fff;
        padding: 1.875rem;
        h3 {
          font-size: 2.25rem;
          color: #424451;
          text-align: center;
        }
        .line {
          width: 100%;
          margin: 0.75rem 0 0;
          height: 0.125rem;
          background: linear-gradient(
            to right,
            rgba(170, 229, 239, 1),
            rgba(177, 187, 255, 1)
          );
        }
        .contact_us {
          font-size: 1.375rem;
          margin: 1.5rem 0;
          font-family: SourceHanSansCN-Medium;
        }
        .contact_item {
          width: 100%;
          font-size: 1.125rem;
          p {
            margin: 1rem 0;
          }
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
    padding-bottom: 1.6667rem;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    .tabList_item {
      height: 1.8333rem;
      line-height: 1.8333rem;
      padding: 0 1rem;
      background: #f0f1f2;
      font-size: 0.8333rem;
      margin-right: 0.9167rem;
      cursor: pointer;
      &.active {
        background: #6b6d7a;
        color: #fff;
      }
    }
    .article_con {
      background: #fff;
      width: 100%;
      box-sizing: border-box;
      margin-top: 2rem;

      h3 {
        font-size: 1.5rem;
        color: #424451;
        text-align: center;
      }
      .line {
        width: 100%;
        margin: 0.75rem 0 0;
        height: 0.0833rem;
        background: linear-gradient(
          to right,
          rgba(170, 229, 239, 1),
          rgba(177, 187, 255, 1)
        );
      }
      .contact_us {
        font-size: 1.375rem;
        margin: 1.5rem 0;
        font-family: SourceHanSansCN-Medium;
      }
      .contact_item {
        width: 100%;
        font-size: 1rem;
        p {
          margin: 1rem 0;
        }
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
  .detail_con {
    margin-top: 2rem;
    color: #666 !important;
    font-size: 1.125rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 2.5rem !important;
    p,
    span {
      color: #666 !important;
      font-size: 1.125rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 2.5rem !important;
    }
  }
  .app_detail_con {
    margin-top: 1.6667rem;
    color: #666 !important;
    font-size: 1rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 1.8333rem !important;
    p,
    span {
      color: #666 !important;
      font-size: 1rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 1.8333rem !important;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
